import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=26fa33db"
import script from "./ReviewForm.vue?vue&type=script&lang=js"
export * from "./ReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports